class App {
  constructor() {
    this.components = [];
    this.init();
  }

  init() {
    this.initComponents();
    this.setupGlobalEvents();
    console.log('🚀 Mahta Storefront initialized');
  }

  initComponents() {
    try {
      console.log('AnnouncementBar initialized');
    } catch (error) {
      console.warn('Failed to initialize AnnouncementBar:', error);
    }

    try {
      const countdownElements = document.querySelectorAll(
        '.campaign-countdown:not(.announcement-bar .campaign-countdown)'
      );
      countdownElements.forEach(element => {
        this.initCountdown(element);
      });
    } catch (error) {
      console.warn('Failed to initialize standalone countdowns:', error);
    }
  }

  initCountdown(element) {
    const endDate = element.getAttribute('data-end-date');
    if (!endDate) return;

    const style = element.getAttribute('data-style') || 'horizontal';
    const color = element.getAttribute('data-color') || '#333333';
    const size = element.getAttribute('data-size') || '16';
    const background = element.getAttribute('data-background') || '#ffffff';
    const borderColor = element.getAttribute('data-border-color') || '#333333';
    const borderWidth = element.getAttribute('data-border-width') || '2';
    const borderRadius = element.getAttribute('data-border-radius') || '4';

    function update() {
      const now = new Date().getTime();
      const end = new Date(endDate + 'T23:59:59').getTime();
      const distance = end - now;

      if (distance < 0) {
        element.style.display = 'none';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let html = '';

      if (style === 'squares') {
        const squareStyle = `width: 40px; height: 40px; border: ${borderWidth}px solid ${borderColor}; background: ${background}; border-radius: ${borderRadius}px; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: ${size}px; color: ${color};`;

        if (days > 0) {
          html += `<div style="${squareStyle}">${days}</div>`;
          html += `<span style="font-size: 12px; color: #666; margin: 0 4px;">D</span>`;
        }
        if (hours > 0) {
          html += `<div style="${squareStyle}">${hours}</div>`;
          html += `<span style="font-size: 12px; color: #666; margin: 0 4px;">H</span>`;
        }
        if (minutes > 0) {
          html += `<div style="${squareStyle}">${minutes}</div>`;
          html += `<span style="font-size: 12px; color: #666; margin: 0 4px;">M</span>`;
        }
        html += `<div style="${squareStyle}">${seconds}</div>`;
        html += `<span style="font-size: 12px; color: #666; margin: 0 4px;">S</span>`;
      } else {
        let text = '';
        if (days > 0) text += days + 'D ';
        if (hours > 0) text += hours + 'H ';
        if (minutes > 0) text += minutes + 'M ';
        text += seconds + 'S';
        html = `<span style="color: ${color}; font-size: ${size}px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; background: ${background}; border: ${borderWidth}px solid ${borderColor}; border-radius: ${borderRadius}px; padding: 8px 12px;">${text}</span>`;
      }

      element.innerHTML = html;
    }

    update();
    setInterval(update, 1000);
  }

  setupGlobalEvents() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseComponents();
      } else {
        this.resumeComponents();
      }
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.handleResize();
      }, 250);
    });

    window.addEventListener('beforeunload', () => {
      this.destroy();
    });
  }

  pauseComponents() {
    this.components.forEach(component => {
      if (component.pause) {
        component.pause();
      }
    });
  }

  resumeComponents() {
    this.components.forEach(component => {
      if (component.resume) {
        component.resume();
      }
    });
  }

  handleResize() {
    this.components.forEach(component => {
      if (component.handleResize) {
        component.handleResize();
      }
    });
  }

  destroy() {
    this.components.forEach(component => {
      if (component.destroy) {
        component.destroy();
      }
    });
    this.components = [];
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.app = new App();
  });
} else {
  window.app = new App();
}
